import React, { useState, useEffect } from 'react';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import AdminSidebarItems from './AdminSidebarItems';
import { MenuLogo } from '../Sidebar/SidebarLogos';

const AdminSidebar = () => {
  const [sidebarShow, setSidebarShow] = useState(true);

  const handleShowSidebar = () => {
    setSidebarShow(!sidebarShow);
  };


  useEffect(() => {
    const width = window.innerWidth
    if (width <= 820) {
      setSidebarShow(false)
    }
  }, [])

  return (
    <>
      <div className={`AdminDashboard ${sidebarShow ? 'show' : ''}`}>
        <div className="sidebar-title">
          <button className="sidebar-toggle" onClick={handleShowSidebar}>
            <MenuLogo />
          </button>
        </div>
        <AdminSidebarItems />
      </div>
    </>
  );
};

export default AdminSidebar;
